module.exports = __webpack_public_path__ + "img/fb.fb1345db.svg";